// Author XXL
// Date 2021-03-19 18:16:52

class SithMesInventoryAreaLoc {
constructor({
        id = null,
        code = '',
        areaName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.areaName = areaName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryAreaLoc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'areaName',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.grid.areaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    codeFilter : "",
    areaNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'areaNameFilter',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.filter.areaName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'areaName',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.entity.areaName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryAreaLoc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryAreaLoc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
